/**
 * Розраховує ціну з урахуванням знижки
 * @param {number} price - базова ціна
 * @param {number} discount - відсоток знижки (0-100)
 * @param {boolean} isDoctor - чи є користувач лікарем (знижка не застосовується)
 * @param {boolean} shouldCeil - чи округлювати вгору
 * @returns {number} фінальна ціна
 */
export const calculateDiscountedPrice = (price, discount, isDoctor, shouldCeil = false) => {
    if (!discount || isDoctor) return price;

    const discountedPrice = price - (price * discount / 100);
    return shouldCeil ? Math.ceil(discountedPrice) : discountedPrice;
};
